import React, { FC } from 'react';
import { Button } from '@components/UIKit/Button/Button';
import { Toy } from '@specs/views';
import { useTranslation } from '@hooks/useTranslation';
import { useRouter } from 'next/router';
import { LinksEnum } from '@specs/navigation';
interface Props {
  slug: Toy.Single['slug'];
}
export const SellToyButton: FC<Props> = ({
  slug
}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const sellToyHandler = async () => {
    await router.push({
      pathname: LinksEnum.TOY_SELL,
      query: {
        slug
      }
    });
  };
  return <Button id='toy_card_sell_toy_button' color={'White'} size={'medium'} onClick={sellToyHandler} data-sentry-element="Button" data-sentry-component="SellToyButton" data-sentry-source-file="SellToyButton.tsx">
            {tr({
      id: 'btn.sell'
    })}
        </Button>;
};